import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-custom-cutoff": "",
  class: "flex flex-wrap items-end gap-4 rounded-[10px] border border-gray-200 bg-white px-[22px] py-5"
}
const _hoisted_2 = {
  key: 0,
  "data-opens-help": "",
  class: "m-0 text-sm text-gray-600"
}
const _hoisted_3 = { class: "flex flex-wrap items-end gap-4" }

import { computed, ref } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'
import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import TextWithHint from '@/components/neue/wizard/TextWithHint.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import {
  CUTOFF_PRESETS,
  DROP_CHARGE_NOTE,
  DROP_HINT_LABEL,
  LIMIT_OPTIONS,
  MAX_CUTOFF_DAYS_BEFORE,
  OPENS_OPTIONS,
  QUARTER_HOURS,
  sectionCopy
} from '@/config/fulfillmentWizardSteps'
import { describeOpens, dropExplainer } from '@/helpers/fulfillmentWizardSchedule'


export default {
  __name: 'StepOrdering',
  setup(__props) {

const wizard = injectWizard()
const schedule = computed(() => wizard.data.schedule)
const dropHint = computed(() => dropExplainer(wizard))
const opensHelp = computed(() => describeOpens(wizard.preview.value, { data: wizard.data, tz: wizard.timeZone.value }))
const closes = computed(() => schedule.value.closes)

const pickCutoff = preset => {
  closes.value.preset = preset.value
  if (preset.daysBefore !== null) {
    closes.value.daysBefore = preset.daysBefore
    closes.value.time = preset.time
  }
}

const opensOptions = computed(() =>
  OPENS_OPTIONS.filter(o => o.value !== 'previous' || schedule.value.rhythm !== 'once').map(o => ({
    name: o.name,
    value: o.value
  }))
)
const opensValue = computed(() => {
  const { kind, days } = schedule.value.opens
  if (kind === 'days_before') return days === 7 ? 'week_before' : 'three_days'
  return kind
})
const pickOpens = value => {
  const option = OPENS_OPTIONS.find(o => o.value === value)
  schedule.value.opens = option.days ? { kind: 'days_before', days: option.days } : { kind: option.value, days: null }
}

const limitOn = ref(schedule.value.limit !== null)
const pickLimit = on => {
  limitOn.value = on
  if (!on) schedule.value.limit = null
  else if (schedule.value.limit === null) schedule.value.limit = 10
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('closes', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, { label: "Ordering closes" }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CUTOFF_PRESETS), (preset) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: preset.value,
                compact: "",
                name: groupName,
                title: preset.label,
                subtitle: preset.subtitle,
                chip: preset.recommended ? 'Recommended' : '',
                selected: closes.value.preset === preset.value,
                onSelect: $event => (pickCutoff(preset))
              }, null, 8, ["name", "title", "subtitle", "chip", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        }),
        (closes.value.preset === 'custom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(NumberStepper, {
                modelValue: closes.value.daysBefore,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((closes.value.daysBefore) = $event)),
                name: "Days before production",
                min: 0,
                max: _unref(MAX_CUTOFF_DAYS_BEFORE)
              }, null, 8, ["modelValue", "max"]),
              _createVNode(SelectInput, {
                modelValue: closes.value.time,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((closes.value.time) = $event)),
                name: "At",
                options: _unref(QUARTER_HOURS)
              }, null, 8, ["modelValue", "options"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(TextWithHint, {
          text: _unref(DROP_CHARGE_NOTE),
          label: _unref(DROP_HINT_LABEL),
          hint: dropHint.value
        }, null, 8, ["text", "label", "hint"])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('opens', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createVNode(PillRadioGroup, {
          "model-value": opensValue.value,
          label: "Ordering opens",
          options: opensOptions.value,
          "onUpdate:modelValue": pickOpens
        }, null, 8, ["model-value", "options"]),
        (opensHelp.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(opensHelp.value), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('limit', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PillRadioGroup, {
            "model-value": limitOn.value,
            label: "Order limit",
            options: _unref(LIMIT_OPTIONS),
            "onUpdate:modelValue": pickLimit
          }, null, 8, ["model-value", "options"]),
          (limitOn.value)
            ? (_openBlock(), _createBlock(NumberStepper, {
                key: 0,
                "model-value": schedule.value.limit,
                name: "Orders per date",
                min: 1,
                step: 5,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (schedule.value.limit = $event ?? 0))
              }, null, 8, ["model-value"]))
            : _createCommentVNode("", true)
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "m-0 text-sm text-gray-600" }, "When the limit is reached the date shows as Sold Out.", -1))
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}